function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventPremier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 6",
    cx: 56,
    cy: 56,
    r: 56,
    style: {
      fill: "#64e1dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 136",
    d: "M202.195 120.214a56.367 56.367 0 0 0-.8-9.476l-28.543-28.544L127.3 103.4l-11.85 52.207 19.469 19.469a56.05 56.05 0 0 0 67.276-54.864z",
    transform: "translate(-90.195 -64.214)",
    style: {
      fill: "#00c1bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 137",
    d: "M115.449 236.1h61.561v39.748h-61.561z",
    transform: "translate(-90.195 -184.455)",
    style: {
      fill: "#555a66"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 138",
    d: "M255.986 236.1H286.8v39.748h-30.814z",
    transform: "translate(-199.989 -184.455)",
    style: {
      fill: "#333940"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 23"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 139",
    d: "M177.01 199.332h-7.632l-3.225-.256-3.916.256h-8.872l-3.493-.214-3.642.214H138l-3.225-.183-3.945.183h-8.245l-3.3-.3-3.837.3v-12.023h7.622l3.263.5 3.888-.5h8.239l3.507.328 3.644-.328h8.229l3.335.17 3.827-.17h8.857l3.318.2 3.833-.2z",
    transform: "translate(-90.195 -146.335)",
    style: {
      fill: "#707789"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 140",
    d: "m282.971 187.51-3.318-.2H270.8l-3.827.17-3.335-.17h-7.649v12.023h.038l3.642-.214 3.493.214h8.872l3.916-.256 3.225.256h7.625v-12.024z",
    transform: "translate(-199.99 -146.335)",
    style: {
      fill: "#555a66"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 141",
    d: "M336.489 199.332h-7.151l7.622-12.023h7.151z",
    transform: "translate(-257.296 -146.335)",
    style: {
      fill: "#e9edf5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 142",
    d: "M263.311 199.332h-7.151l7.622-12.023h7.151z",
    transform: "translate(-200.125 -146.335)",
    style: {
      fill: "#e9edf5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 143",
    d: "M192.955 199.332H185.8l7.622-12.023h7.151z",
    transform: "translate(-145.16 -146.335)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 144",
    d: "M122.6 199.332h-7.151l7.622-12.023h7.151z",
    transform: "translate(-90.195 -146.335)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 24"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 145",
    d: "m166.55 93.9-7.431 1.742-3.2.487-3.754 1.143-8.636 2.028-3.45.589-3.5 1.04-8.013 1.878-3.181.558-3.8 1.078-8.027 1.882-3.279.462-3.668 1.166-2.741-11.708 7.421-1.74 3.29-.262 3.672-1.37 8.022-1.881 3.49-.481 3.472-1.151 8.012-1.878 3.285-.6 3.687-1.039 8.623-2.021 3.276-.561 3.686-1.071z",
    transform: "translate(-81.148 -64.214)",
    style: {
      fill: "#636978"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 146",
    d: "m282.646 82.194-3.686 1.071-3.276.561-8.623 2.021-3.687 1.039-3.285.6-4.1.962v12.314l2.934-.872 3.45-.589 8.638-2.025 3.754-1.143 3.2-.487 7.43-1.742z",
    transform: "translate(-199.989 -64.214)",
    style: {
      fill: "#414952"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 147",
    d: "m331.62 95.639-6.962 1.632 4.676-13.445 6.962-1.632z",
    transform: "translate(-253.639 -64.214)",
    style: {
      fill: "#e9edf5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 148",
    d: "m260.373 112.341-6.962 1.632 4.676-13.445 6.963-1.628z",
    transform: "translate(-197.977 -77.262)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 149",
    d: "m267.061 98.9-6.962 1.632-4.113 11.826v1.487l6.4-1.5z",
    transform: "translate(-199.989 -77.262)",
    style: {
      fill: "#e9edf5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 150",
    d: "m191.875 128.4-6.962 1.632 4.676-13.445 6.962-1.632z",
    transform: "translate(-144.463 -89.808)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 151",
    d: "m123.377 144.457-6.962 1.632 4.676-13.446 6.962-1.632z",
    transform: "translate(-90.949 -102.353)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 152",
    d: "m220.493 277-9.584-1.393-4.325-8.607-4.248 8.608-9.584 1.392 6.935 6.76-1.637 9.546 8.535-4.491 8.61 4.491-1.637-9.546z",
    transform: "translate(-150.587 -208.595)",
    style: {
      fill: "#ffd400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 153",
    d: "m269.894 277-9.584-1.393-4.324-8.607v21.816l8.61 4.491-1.637-9.546z",
    transform: "translate(-199.989 -208.595)",
    style: {
      fill: "#fdba12"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventPremier);
export default __webpack_public_path__ + "static/media/event-premier.4c97227f5cd5ca48e73b36985bcb925a.svg";
export { ForwardRef as ReactComponent };